import {Route, Routes} from "react-router-dom";
import {Toaster} from "react-hot-toast";
import Dashboard from "./modules/dashboard/Dashboard";
import AuthMiddleware from "./core/middlewares/AuthMiddleware";
import Login from "./modules/auth/Login";
import EditProfile from "./modules/auth/EditProfile";
import AuthService from "./modules/auth/Service";
import {useEffect, useState} from "react";
import {refreshTokenSuccess} from "./core/providers/auth/reducers";
import store from "./core/providers";
import AddUser from "./modules/user/AddUser";
import ManageUsers from "./modules/user/ManageUser";
import EditUser from "./modules/user/EditUser";
import CreateOrder from "./modules/order/CreateOrder";
import './App.css';
import AddProduct from "./modules/product/AddProduct";
import EditProduct from "./modules/product/EditProduct";
import ManageProducts from "./modules/product/ManageProducts";
import ManageConfig from "./modules/config/ManageConfig";
import ManageOrders from "./modules/order/ManageOrders";
import OrderDetails from "./modules/order/OrderDetails";
import ManageCards from "./modules/card/ManageCards";
import CardDetails from "./modules/card/CardDetails";

function App() {
    const [authService] = useState(new AuthService());


    useEffect(() => {
        const token = localStorage.getItem('token');
        console.log(token);
        if (token) {
            authService.refreshToken().then(user => {
                if (user !== null) {
                    store.dispatch({type: refreshTokenSuccess, payload: user});
                }
            });
        }
    }, [authService]);


    return (
        <>

            <Routes>


                <Route
                    path="/login"
                    element={
                        <Login/>
                    }
                />
                <Route
                    path="/edit-profile"
                    element={
                        <AuthMiddleware>
                            <EditProfile/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/"
                    element={
                        <AuthMiddleware>
                            <Dashboard/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/users/add"
                    element={
                        <AuthMiddleware>
                            <AddUser/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/users"
                    element={
                        <AuthMiddleware>
                            <ManageUsers/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/users/edit/:id"
                    element={
                        <AuthMiddleware>
                            <EditUser/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/orders/create"
                    element={
                        <AuthMiddleware>
                            <CreateOrder/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/orders"
                    element={
                        <AuthMiddleware>
                            <ManageOrders/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/orders/details/:id"
                    element={
                        <AuthMiddleware>
                            <OrderDetails/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/products/add"
                    element={
                        <AuthMiddleware>
                            <AddProduct/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/products"
                    element={
                        <AuthMiddleware>
                            <ManageProducts/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/products/edit/:id"
                    element={
                        <AuthMiddleware>
                            <EditProduct/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/configs"
                    element={
                        <AuthMiddleware>
                            <ManageConfig/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/cards"
                    element={
                        <AuthMiddleware>
                            <ManageCards/>
                        </AuthMiddleware>
                    }
                />

                <Route
                    path="/cards/details/:id"
                    element={
                        <AuthMiddleware>
                            <CardDetails/>
                        </AuthMiddleware>
                    }
                />

            </Routes>
            <Toaster/>
        </>
    );
}

export default App;
